import { apiClient } from '../../axios';
import { GetAuctionResponse, PostAuctionBidRequest } from './types';

export const getAuctionApi = () => apiClient.get<GetAuctionResponse>('/v1/auction');

export const postAuctionBidApi = (id: string, data: PostAuctionBidRequest) =>
  apiClient.post(`/v1/auction/${id}/bid`, data);
